import { render, staticRenderFns } from "./bid-selector.vue?vue&type=template&id=c9bd64d8"
import script from "./bid-selector.vue?vue&type=script&lang=js"
export * from "./bid-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports